import React, { Component } from "react";

import styles from "./winterUnitsBar.module.scss";
import WinterUnitListItem from "./WinterUnitListItem";
import { withWinter } from "../../../../shared/containers/containerWinter";

class WinterUnitsListItems extends Component {
  render() {
    const { handleScrollTo, data, winterUnits, selectedWinterGroup } = this.props;

    return data.map((item) => {
      let isCheck = false;

      if (selectedWinterGroup !== null) {
        const winterUnit = winterUnits.filter((x) => {
          return x.id === item.id;
        })[0];

        if (winterUnit !== undefined) {
          isCheck = winterUnit.groups.some((x) => {
            return x.id === selectedWinterGroup.id;
          });
        } else {
          return null;
        }
      } else {
        isCheck = winterUnits.some((x) => {
          return x.id === item.id;
        });
      }

      return (
        <div className={styles.container_winterUnitsListItem} key={item.id}>
          <WinterUnitListItem data={item} handleScrollTo={handleScrollTo} isCheck={isCheck} />
        </div>
      );
    });
  }
}

export default withWinter(React.memo(WinterUnitsListItems));
